import React from 'react';
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';

const ICONS = { info: Info, success: CheckCircle2, warning: AlertTriangle, danger: XCircle };

/**
 * A quiet inline note with an icon. Replaces Bootstrap's Alert on the account
 * pages, where a boxed, full-colour alert made every explanatory sentence look
 * like an error.
 */
export default function Callout({ tone = 'info', role, className = '', children }) {
    const Icon = ICONS[tone] || Info;
    return <div className={`ll-callout ll-callout--${tone} ${className}`.trim()} role={role}>
        <Icon size={16} strokeWidth={2} className="ll-callout__icon" aria-hidden="true" />
        <div className="ll-callout__body">{children}</div>
    </div>;
}
